import React, { Dispatch, createContext, useReducer } from 'react';

import { HTTP_REQUEST_FINISHED, HTTP_REQUEST_STARTED } from './constants';
import { ActionTypes, State } from './types';

const initialState: State = {
  isLoading: false,
  config: {
    initialPath: '',
    language: '',
    sgUrl: '',
    signUpUrl: '',
    recaptchaToken: ''
  }
};

const StoreContext = createContext<{
  state: State;
  dispatch: Dispatch<ActionTypes>;
}>({
  state: initialState,
  dispatch: () => null
});

const StoreProvider = ({ children, config }) => {
  const defaultState = {
    ...initialState,
    config: {
      ...initialState.config,
      ...config,
      language: config.language.split('_').shift()
    }
  };

  const [state, dispatch] = useReducer((state: State, action: ActionTypes) => {
    switch (action.type) {
      case HTTP_REQUEST_STARTED:
        return { ...state, isLoading: true };
      case HTTP_REQUEST_FINISHED:
        return { ...state, isLoading: false };
      default:
        return state;
    }
  }, defaultState);

  return <StoreContext.Provider value={{ state, dispatch }}>{children}</StoreContext.Provider>;
};

export { StoreContext, StoreProvider };
